import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import "rxjs/add/operator/debounceTime";
import 'rxjs/Rx';


@Component({
  selector: "app-sandbox-dashboard",
  templateUrl: "./sandbox-dashboard.component.html",
  styleUrls: ["./sandbox-dashboard.component.scss"],
  encapsulation: ViewEncapsulation.None
})
export class SandBoxDashboardComponent implements OnInit {
  groupList = [];
  widgetListGroup = [];
  constructor() {
  }

  ngOnInit() {    
    let data: any = JSON.parse(localStorage.getItem('dta'));    
    if (data) {
      this.groupList = data.groups;
      this.widgetListGroup = data.widgets;
    }
  }


  applyWidgetWidth(widget, defaultSize) {
    return (
      widget.widgetConfig && widget.widgetConfig.width > 0
        ? widget.widgetConfig.width
        : defaultSize);
  }

  applyWidgetHeight(widget) {
    if (widget.fetchDataFor == 'geomap' && widget.widgetConfig.height) {
      return widget.widgetConfig.height + 'px';
    }
  }

}




// WEBPACK FOOTER //
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/sandbox-dashboard/sandbox-dashboard.component.ts